import React from 'react';
import MainPageCompenent from './MainPageCompenent';
import MerchantLotteriesList from './MerchantLotteriesList';

function MerchantLotteries(props) {
    return (
        <MainPageCompenent>
            <MerchantLotteriesList />
        </MainPageCompenent>
    );
}

export default MerchantLotteries;